import { useMutation } from "@apollo/client";
import { UpdateAddressDocument } from "@/__generated__/graphql";

export const useUpdateAddressMutation = () => {
  return useMutation(UpdateAddressDocument);
};
